module.exports = __webpack_public_path__ + "img/field_watch2_icon.fcb8b336.svg";